import React from "react";
import SegmentPage from "../components/aa/SegmentPage";
import { EXP_TRANSLATIONS, EXP_IMAGES } from "../data/experiences";

export default function ExperiencesPage() {
  return <SegmentPage translations={EXP_TRANSLATIONS} images={EXP_IMAGES} />;
}
